import _ from 'lodash'

const RewriteMediaUrl = (text = '') => {
  const env = process.env.GATSBY_API_STAGE;
  const filePrefix = process.env.GATSBY_API_CHANNEL_CODE;
  const dns = process.env.GATSBY_API_URL.replace('https://', '');

  let site = '';
  switch (filePrefix) {
    case 'tsh_web_fr':
      site = 'https://www.teleshopping.fr'
      break
    case 'tsh_web_be':
      site = 'https://www.teleshopping.be'
      break
    case 'tsh_web_cat':
      site = 'https://catalogue.teleshopping.fr'
      break
    case 'esh_web_fr':
      site = 'https://www.euroshopping.fr'
      break
    case 'esh_web_be':
      site = 'https://www.euroshopping.be'
      break
    case 'm6b_web_fr':
        site = 'https://www.m6boutique.com'
        break    
    case 'mbt_web_fr':
        site = 'https://www.myboutiqueteleshop.com'
        break
    case 'mbt_web_cat':
        site = 'https://catalogue.myboutiqueteleshop.com'
        break
    case 'm6b_web_cat':
      site = 'https://catalogue.m6boutique.com'
      break
    case 'm6b_web_be':
      site = 'https://www.m6boutique.be'
      break
    default:
      site = ''
  }
  const correctUrl = () => {
    // if env = dev => media-<link>
    // if env = preprod && site Url contains 'boutique' => media-<link>
    // else => media.<link>
    return `${
      env === 'dev' ? 
        "-" : 
        env === 'pprd' && site.includes('boutique') ?
          '-' :
          '.'
      }${
        dns.replace('www.','')
    }`
  }

  const REWRITE_RULES = {
    [`https://stars-ecom${env === 'prod' ? 'new' : env}-web-datasync.s3.eu-west-3.amazonaws.com/`]: `https://media${correctUrl()}/`,
    [`${site}/media/catalog/product/jpg/`]: `https://media${correctUrl()}/eurojpg/`,
    ['/media/catalog/product/jpg/']: `https://media${correctUrl()}/eurojpg/`,
    [`${site}/skin/market/rsd/`]: `https://media${correctUrl()}/skin/market/rsd/`,
    ['/skin/market/rsd/']: `https://media${correctUrl()}/skin/market/rsd/`
  }

  let finalResult = text || ''

  Object.keys(REWRITE_RULES).forEach((rule) => {
    const regexpInText = new RegExp(`(href="|src=")(${_.escapeRegExp(rule)})([^"]*"[^>]*>)`, 'g')
    const regexpInUrl = new RegExp(`(${_.escapeRegExp(rule)})`, 'g')
    
    if (finalResult.search(regexpInText) >= 0)
      finalResult = finalResult.replace(regexpInText, `$1${REWRITE_RULES[rule]}$3`)
    else if (finalResult.search(regexpInUrl) >= 0)
      finalResult = finalResult.replace(regexpInUrl, `${REWRITE_RULES[rule]}`)
  })

  return finalResult
}

export default RewriteMediaUrl
